import * as signalR from "@microsoft/signalr";

export class CustomReportsHttpClient extends signalR.DefaultHttpClient {

  private _application;
  private _project;
  private _template;
  constructor(application, project, template) {
    super(console);
    this._application = application;
    this._project = project;
    this._template = template;
  }

  public async send(request: signalR.HttpRequest): Promise<signalR.HttpResponse> {
    request.headers = {
      ...request.headers,
      ProjectId: this._project,
      TemplateId: this._template,
      Key: (this._project && this._template) ? `${this._project}$${this._template}` : '',
      ApplicationId: String(this._application),
    };
    return super.send(request);
  }
}
